import { fetchErrors } from '../strings.en';
import { months, weekdays } from '../strings.fi';

const status = {
  DONE: 'Tehty',
  DONE_WITH_DEVIATION: 'Tehty poikkeamalla',
  IN_PROGRESS: 'Käynnissä',
  UNKNOWN: 'Suunniteltu ',
};

export default {
  tabSE: 'DeliveryPortal Sweden',
  tabFI: 'DeliveryPortal Finland',
  disclaimer: {
    text: 'Huomaa, että tämä ei ole rakennusasiakirja.',
    proceedButton: 'OK',
  },
  geolocation: {
    text: 'Sijaintisi käyttöoikeus puuttuu. Päivitä laitteesi asetukset manuaalisesti näyttääksesi nykyisen sijainnin.',
    proceedButton: 'OK',
  },
  home: 'Koti',
  location: 'Sijaintisi',
  info: 'Tiedot',
  menu: 'Valikko',
  orders: 'Tilaukset',
  reportsMenu: 'Raportit ',
  reportsPanel: {
    empty: 'Raportteja ei ole saatavilla.',
    filterPlaceholder: 'Suodata raporttityypin mukaan',
    searchPlaceholder: 'Hae raportteja',
    hideCompleted: 'Piilota valmiit raportit',
    types: {
      span: 'Linja',
      cabinet: 'Kaappi',
      manhole: 'Kaivo',
      kp: 'KP',
      hc: 'HC',
      site: 'Site',
      hub: 'Hub',
    },
  },
  constructionVersion: 'Rakennusasiakirjan versio',
  constructionExplanation:
    'Rakennusdokumentin viimeisin versio ja julkaisupäivämäärä Duktigissa',
  popup: {
    spanStatus: 'Linjestatus',
    accommodationMethod: ' Asennustapa',
    permissionType: 'Lupatyyppi',
    length: 'Pituus ',
    expandContent: 'Laajenna saadaksesi lisätietoja',
    hideExpandedContent: 'Näytä vähemmän tietoa',
    createReport: {
      span: 'Luo raportti',
      well: 'Luo raportti',
      cabinet: 'Luo raportti',
    },
    updateReport: 'Muokkaa Raporttia',
    existingSpan: 'Tehty (linja on jo olemassa)',
    address: 'Katuosoite',
    name: 'Nimi',
    editSpans: 'Muokkaa linjaa raportissa',
  },
  infoPopup: {
    name: 'Nimi',
    description: 'Kuvaus ',
    freeText: 'Muita tietoja',
  },
  pointInfo: {
    multiDuct: 'Mikrokanavanippu:',
    color: 'Väri:',
    label: 'Label:',
    from: 'Alkaen:',
    duct: 'Mikrokanava:',
    connectedTo: 'Yhdistetty:',
    showMore: 'Näytä lisätietoja',
    showLess: 'Näyttää vähemmän yksityiskohtia',
    informationLoading: 'Tietojen lataaminen',
    informationMissing: 'Putkitiedot puuttuvat',
    ductRow: {
      from: 'Alkaen',
      to: 'Päättyen',
      name: 'Nimi',
      incoming: 'Saapuva',
      outgoing: 'Lähtevä',
    },
  },
  sitePopup: {
    name: 'Nimi',
  },
  hubPopup: {
    name: 'Nimi',
  },
  permitAreaPopup: {
    CREATED: 'Luotu',
    IN_PROGRESS: 'Käynnissä',
    COMPLETED: 'Valmis',
    APPROVED: 'Hyväksytty',
    ADD: 'Lisätä',
    REVISED: 'Kerrata',
    WORK_DONE: 'Työ tehty',
    INSPECTION_COMPLETED: 'Katsastus suoritettu',
    NOT_UTILIZED: 'Ei käytetty',
    REVOKED: 'Kumottu',
    CLOSED_BY_TRV: 'Suljettu trv',
    MISPLACEMENT: 'Väärä sijoitus',
    EXPIRED: 'Vanhentunut',
    SITING_NOT_FILED: 'Siting not filed',
    SITING_PERMIT_FILED: 'Siting permit filed',
    SITING_PERMIT_APPROVED: 'Siting permit approved',
    EXCAVATION_PERMIT_FILED: 'Excavation permit filed',
    EXCAVATION_PERMIT_APPROVED: 'Excavation permit approved',
    type: 'Tyyppi',
    name: 'Nimi',
    description: 'Kuvaus',
    status: 'Tila',
  },
  duct: {
    loading: 'Ladataan tietoja',
    header: 'Mikrokanavat',
    missing: 'Mikrokanavat tiedot puuttuvat',
    from: 'alkaen',
    showSubducts: 'Näytä mikrokanava',
    hideSubducts: 'Piilota mikrokanava',
  },
  noResourceSelected:
    'Aktiivinen projekti puuttuu. Valitse projekti yllä tai ota yhteyttä järjestelmänvalvojaasi saadaksesi lisätietoja.',
  mapDataError: 'Karttatietoja ei voitu hakea.',
  report: {
    tab1: 'Vaihe 1',
    tab2: 'Vaihe 2',
    addReport: 'Lisää kenttäraportti',
    report: 'Kenttäraportti',
    reports: 'Kenttäraportit',
    upload: 'Lataa kuvia',
    download: 'Ladata',
    deviationLength: 'Ilmoitettu poikkeama on ',
    reportedLength: 'Ilmoitettu pituus on ',
    reportHeaders: {
      span: 'Linja',
      length: 'Suunniteltu linjan pituus',
      accommodationMethod: 'Asennustapa',
      status: 'Tila',
      deviationType: 'Määritellä poikkeama',
      comment: 'Kommentit',
      commentField: 'Lisää kommentit',
      commentPlaceholder: 'Lisää edistymiskommentitsi tähän',
      deviationTypes: 'Poikkeama ',
      reportedLength: 'Poikkeaman pituus (m)',
      deviationMethods: 'Asennustapa',
      name: 'Nimi',
      requirement: 'Vaatimus',
      objectType: 'Objektityyppi',

      type: 'Tyyppi',
      well: 'Kaivo',
      slingwell: 'Kaivo',
      cabinet: 'Jakokaappi',
      jointpoint: 'Yhdyspiste',
      info: 'Tietopiste',
      id: 'Id',
      date: 'Raportointipäivä',
      createdBy: 'Luonut',
      contractorComment: 'Urakoitsijan kommentit',
      criteriaReport: 'kriteerit raportti',
      criteriaInfo:
        'Lue alla oleva tarkistuslista ja merkitse suoritetut kohdat. Huomaa, että jotkin kohteet saattavat vaatia kuvan tai videon.',
      validationError: 'Täytä kaikki pakolliset kentät',
      clear: 'Poista',
      calculatedPlannedDeviation: 'Suunniteltu pituus on ',
      plannedDeviationText: 'Syötä poikkeavan osan pituus.',
      calculatedDeviation1: 'Poikkeamaviivan pituus on ',
      calculatedDeviation2: 'Tämä lähtee ',
      calculatedDeviation3:
        'Joka on raportoitava valitsemalla poikkeamamenetelmät.',
      commentDeviationPlaceholder:
        'Ole hyvä ja lisää lisätietoja poikkeamasta.',
    },
    search: 'Hae',
    searchPlaceholder: 'Lisätä id',
    filterStatus: 'Suodata tilan mukaan',
    chooseStatus: 'Valitse tila',
    statusDropdownOption: {
      inProgress: 'Käynnissä',
      done: 'Tehty',
      doneWithDeviation: 'Tehty poikkeaman kanssa',
      unknown: 'Tuntematon',
      all: 'Kaikki',
    },
    filterType: 'Suodata tyypin mukaan',
    status: {
      inProgress: 'Jatkuva',
      done: 'Tehty',
      deviation: 'Tehty poikkeaman kanssa',
    },
    invalidField: {
      deviationType: 'Please choose at least one deviation type',
      comment: 'Kirjoita kommentit poikkeamasta',
      reportedLength: 'Kirjoita rivin kokonaispituus (metreinä)',
      workPerformed: 'Lisää vähintään yksi menetelmä',
      totalLengthError:
        'Varmista, että kokonaispituus on yhtä suuri kuin pituus',
    },
    suppliedMaterial: 'Osa jännevälistä, joka on tapaus B',
    noSuppliedMaterial: 'Ei tietoa',
    notSynced: 'Ei synkronoitu',
    chooseDeviation: 'Valitse poikkeaman tyyppi',
    verificationRequired:
      'Ilmoitettu pituus on yli 50 % suunniteltua pituutta pidempi. Onko tämä oikein?',
    methodDeviation: {
      addMethod: 'Lisää menetelmä',
      dropdownPlaceholder: 'Valitse menetelmä',
      totalLength: 'Kokonaispituus',
      deviationHeader: 'Poikkeaman pituus (m)',
      accomoodationMethod: 'Asennustapa',
    },
    saveReport: 'Tallenna raportti',
    next: 'Seuraava askel',
    dismiss: 'Sulje',
    success: 'Raportti on tallennettu!',
    offline:
      'Raportti on tallennettu offline-tilaan ja se ladataan seuraavan kerran, kun sovellus on online-tilassa.',
    error: 'Raporttia ei voitu tallenna. Yritä uudelleen.',
    backToReports: 'Takaisin raporttiluetteloon',
    open: 'Avoin raportti',
    create: 'Luo raportti',
  },
  projectLevelReport: {
    header: 'projekti raportti',
  },
  installationReport: {
    popUpBtnText: 'Asennuksen raportointi',
    header: 'Asennuksen raportointi',
    saveBtn: 'Tallenna raportti',
    addressLabel: 'Katuosoite',
    toOrdersModal: 'Yleiskatsaus tilauksiin',
    confirmModal: {
      header: ' Haluatko varmasti sulkea lomakkeen?',
      text: 'On muutoksia, joita ei ole tallennettu. Muista Tallenna ne ennen sulkemista.',
      cancelBtn: 'Vie minut takaisin raporttiin',
      closeBtn: 'Joo, sulje',
    },
    missingIdMessage: 'Asennuksen raportointi id puuttuu (sourceKey)',
    saveSuccessMessage: 'Asennusraportti tallennettu onnistuneesti ',
    saveErrorMessage: 'Asennusraporttia ei voitu tallenna. Yritä uudelleen.',
    failToLoadMessage: {
      403: 'Pääsy kielletty, kirjaudu sisään nähdäksesi asennusraportin.',
      404: 'Valitulle asuinpaikalle ei ole saatavana asennusraporttia.',
      408: 'Request Timeout. Lataa sovellus uudelleen.',
      500: 'Palvelinongelmia, yritä myöhemmin uudelleen.',
      general: 'asennusraporttia ei voitu ladata.',
    },
    errorText:
      'Raporttia ei voitu ladata. Lataa raportti uudelleen tai yritä myöhemmin uudelleen.',
    form: {
      planedInstallationDate: 'Suunniteltu asennuspäivä',
      bookedCustomerInstallationDate: 'Varattu asiakkaan asennuspäivämäärä',
      siteProjectPlanningExecutedDate: 'Tonttisuunnittelu Toteutuspäivämäärä',
      siteShaftBooked: 'Varattu Tonttikaivuu',
      siteShaftInstallationDate: 'Tonttikaivuu asennuspäivämäärä',
      fiberCableInstalledForCustomer: 'Asiakkaalle asennettu kuitukaapeli',
      fiberReceiverInstallationDate: 'Kuituvastaanottimen asennuspäivämäärä',
      macAddress: 'MAC-osoite CPE',
      email: 'Sähköposti',
      name: 'Nimi',
      phoneNumber: 'Puhelinnumero',
    },
  },
  installationReportV2: {
    tabNames: {
      ORDER_OVERVIEW: 'Tilauksen tiedot',
      PLOT_DESIGN: 'Tonttisuunnittelu',
      PLOT_EXCAVATION: 'Tonttikaivuu',
      DUCT_CONNECTION: 'Kanavakytkennät',
      PRE_INSTALLATION: 'Esiasennus',
      SPLICING_MEASURING: 'Hitsaus & Mittaus',
      SPLICING: 'Hitsaus',
      COMMISSIONING: 'Käyttöönotto',
      CABLE_BLOWING: 'Kuidun puhallus',
      MEASURING: 'Mittaus',
    },
    modal: {
      header: 'Asennuksen raportointi',
      completedBy: 'Valmistunut: #{user} #{date}',
      closeBtn: 'Sulje',
      saveBtn: 'Tallenna',
      completeBtn: 'Täydellinen raportti',
      unlockReportBtn: 'Avaa raportin lukitus',
      reportCompletedBtn: 'Raportti valmis',
      reportCompletedDisabledTooltip:
        'Ota yhteyttä rakennusvastaavaasi, jotta raportin lukitus voidaan poistaa.',
      completeBtnDisabledTooltip:
        'Raportin voi viimeistellä, kun kaikki vaiheet on saatettu loppuun.',
      onProceedError: 'Lomake ei kelpaa',
      cannotSaveNetAdmin: 'NetAdmin-arvoa ei voi tallentaa.',
    },
    completeConfirmation: {
      title: 'Viimeistelläänkö raportti?',
      whatHappens: 'Mitä tapahtuu, jos vahvistat?',
      bulletInvoice: 'Asiakas laskutetaan suoraan vahvistuksen jälkeen.',
      bulletLocked: 'Koko raportti lukitaan eikä sitä voi muuttaa.',
      checkboxLabel: 'Olen lukenut ja ymmärtänyt yllä olevan tekstin.',
      cancel: 'Peruuta',
      confirm: 'Vahvista',
      completedTitle: 'Raportti valmis!',
      completedBody:
        'Asiakas on tilattu ja lasku on lähetetty! Tätä raporttia ei voi enää muokata.',
      closeWindow: 'Sulje tämä ikkuna',
    },
    plotDesignTab: {
      instructions: 'Täytä tiedot jatkaaksesi.',
      completed: 'Plot Design - Completed!',
      plannedPlotDesign: 'Suunniteltu Tonttisuunnittelu',
      executedPlotDesign: 'Toteutettu Tonttisuunnittelu',
      comment: 'Comment',
    },
    plotExcavationTab: {
      instructions: 'Täytä tiedot jatkaaksesi',
      completed: 'Tonttikaivuu - Valmis!',
      plannedPlotExcavation: 'Suunniteltu Tonttikaivuu',
      executedPlotExcavation: 'Toteutettu Tonttikaivuu',
      comment: 'Kommentit',
      awaitingSign: 'Odotetaan allekirjoitusta',
      completedSign: 'Allekirjoitus tehty',
      initiateSign: 'Aloita allekirjoittaminen',
    },
    ductConnectionTab: {
      instructions:
        'Suorita itsetarkastukset kanavayhteyden viimeistelemiseksi!',
      completed: 'Kanava yhdistetty',
      executedDate: 'Täytäntöönpanopäivä',
      notConnected: 'Ei yhteyttä',
      comment: 'Kommentit',
    },
    orderOverviewTab: {
      infoText:
        'Valitun tilauksen tiedot näytetään alla. Täytä raportit välilehtiin yllä.',
      subHeader: 'Tilaus Informaatio',
      address: 'Katuosoite',
      customerName: 'Asiakkaan nimi',
      email: 'Sähköposti',
      phoneNumber: 'Puhelinnumero',
      connectionType: 'Liittymätyyppi',
      contactedDate: 'Customer Contacted',
      statusReport: 'Raportin tilanne',
      greenfieldIfs: 'Greenfield-IFS',
    },
    preinstallationTab: {
      instructions: 'Näytä tiedot ja suorita tarkistus',
      completed: 'Esiasennus - Valmis!',
      plannedPreinstallation: 'Suunniteltu Esiasennus',
      executedPreinstallation: 'Toteutettu Esiasennus',
      macAddress: 'MAC-Osoite CPE / Sarjanumero',
      macAddressInputLabel:
        'MAC-osoite CPE (P2P) tai Serienummer ONT (XGS-PON)',
      help: 'Apu',
      comment: 'Kommentit',
      netAdmin: 'NetAdmin',
      netAdminHeader: 'ONT / CPE-rekisteröinti',
      netAdminSubHeader:
        'Valitse laite ja täytä arvo alla. Tallenna rekisteröidäksesi!',
      deviceCategory: 'Laitetyyppi',
      deviceValue: 'Laitearvo',
      macSerialPlaceholder: 'MAC / Sarjanumero',
      mustMatchFormat: 'Muodon on vastattava:',
      netAdminStatus: {
        saveToUpload:
          'Täytä MAC-osoite CPE / Sarjanumero ja tallenna ladataksesi!',
        notSaved: 'Ei tallennettu',
        cannotUpload:
          'Tallennettu - mutta ei voi ladata ilman suorituspäivää ja suoritettuja itsetarkastuksia.',
        clickSave: 'Lataa NetAdminiin napsauttamalla Tallenna!',
        uploading: 'MAC-osoite CPE / Sarjanumero on lähetetty NetAdminille!',
        uploaded: 'Lähetetty ja tallennettu',
      },
      inputPlaceHolder: 'MAC-osoite CPE tai Sarjanumero',
      maxInput: 'Enintään 17 merkkiä sallittu.',
      incorrectFormat: 'Virheellinen muoto, katso Ohjeet ohjeita varten.',
      model: 'Malli',
      selection: 'Valinta',
    },
    commissioningTab: {
      instructions: 'Täytä tiedot ja lataa tiedostot!',
      completed: 'Käyttöönotto - Valmis!',
      plannedCommissioning: 'Suunniteltu Käyttöönotto',
      executedCommissioning: 'Toteutettu Käyttöönotto',
      plannedMeasuring: 'Suunniteltu Mittaus',
      executedMeasuring: 'Toteutettu Mittaus',
      comment: 'Kommentit',
    },
    splicingAndMeasuringTab: {
      instructions: 'Täytä tiedot ja lataa tiedostot!',
      completed: 'Hitsaus & Mittaus - Valmis!',
      plannedMeasuring: 'Suunniteltu mittaus',
      executedMeasuring: 'Toteutettu mittaus',
      plannedSplicing: 'Suunniteltu hitsaus',
      executedSplicing: 'Toteutettu hitsaus',
      fileAndImageUpload: 'Tiedoston ja kuvan lataus',
      upload: 'Lataa',
      showImages: 'Näytä kuvat',
      comment: 'Kommentit',
      commentDescriptionExplanation:
        'Kerro syy, miksi et seuraa paneelikorttia.',
      fiberData: {
        title: 'Kuitutiedot',
        panelcard: {
          question: 'Onko Panelcardia noudatettu?',
          yes: 'Kyllä',
          no: 'Ei',
        },
        switchName: 'Kytkimen nimi',
        switchPort: 'Kytkinportti',
        switchCard: 'Kytkinkortti',
        odfInSite: 'ODF aktiivilaitepaikassa',
        odfContact: 'ODF liitin',
        cabinet: 'JK (jakokaappi) / VKJK (valokuitujakokaappi)',
        cableIdCabinet: 'VKJK (valokuitujakokaappi)',
        fiberInCabinet: 'Kuitu JK:ssa / VKJK:ssa',
        ductColorInCabinet: 'Putken väri JK:ssa / VKJK:ssa',
        splitterPort: 'Jakajan portti',
        splitterName: 'Jakajan nimi',
        placeholders: {
          syntax: 'NNNN000-NN0',
          number: 'Number',
          focType: 'Type FOC',
          focCableId: 'Type Cable ID',
          color: 'Type duct color',
          name: 'Kirjoita nimi',
          select: 'Valitse',
        },
        descriptions: {
          switchNameSyntax: 'Suositeltu muoto NNNNN0000-NN0',
        },
      },
      toast: {
        notFollowingPanelcard:
          'Kerro kommentissa syy, miksi et seuraa paneelikorttia.',
      },
    },
    cableBlowingTab: {
      instructions: 'Täytä tiedot suorittaaksesi tämän hetken.',
      completed: 'Cable Blowing - Valmis!',
      plannedCableBlowing: 'Suunniteltu Käyttöönotto',
      executedCableBlowing: 'Toteutettu Käyttöönotto',
      comment: 'Kommentit',
    },
    selfInspection: {
      markAsComplete: 'Merkitse tehdyksi',
      uploadImage: 'Lataa kuva',
      showControlled: 'Näytä tarkistetut',
      undoSelfInspection: 'Peruuttaa itsetarkastus',
      handleImage: 'Käsittele kuvia',
      showAttachments: 'Näytä liitteet',
      updateSelfInspectionErrorMessage:
        'Itsetarkistuksen tallentaminen epäonnistui',
      notApplicableText: 'Selitä syy, miksi sitä ei voida soveltaa',
      cancel: 'Peruuta',
      markAsNonApplicable: 'Merkitse ei-soveltuvaksi',
      notApplicable: 'Ei sovelleta',
      editNotApplicableComment: 'Muokkaa kuvausta',
      saveChanges: 'Tallenna muutokset',
      updateSelfInspectionSuccessMessage: 'Kuvaus tallennetaan ja päivitetään',
      selfInspectionSavedSuccessMessage: 'Itsetarkastus on tallennettu',
      revertSelfInspectionMessage: 'Itsetarkastus palautettu onnistuneesti',
      updateSelfInspectionFilesMessage:
        'Itsetarkastustiedostot päivitettiin onnistuneesti',
      updateSelfInspectionRevertedMessage: 'Kuvien lataaminen peruttiin',
      uploadSelfInspectionImageSuccess: 'Kuva ladattu!',
      uploadSelfInspectionImageError: 'Kuvaa ei voitu ladata. Yritä uudelleen!',
      deleteSelfinspectionImageSuccess: 'Kuva on poistettu.',
      deleteSelfinspectionImageError: 'Kuvaa ei voitu poistaa.',
      loadingImages: 'Ladata kuvia...',
      instructionalImage: {
        DepthExampleImage: 'Sisällytä viivain valokuvaan - Katso esimerkki',
      },
      done: 'Tehty: ',
      na: 'N/A: ',
    },
    updateInstallationReportSuccess: 'Muutoksesi on tallennettu',
    updateInstallationReportError: 'Muutoksiasi ei voitu tallenna',
    clearDate: 'Tyhjennä päivämäärä',
    alerts: {
      executedDateAlert: 'Varmista, että kaikki itsetarkastukset on suoritettu',
      signReady: 'Valmiina allekirjoitettavaksi',
    },
    imageChecklist: {
      title: 'Kuvan tarkistuslista',
      listItems: {
        splicingOutlet: 'Kuva liitoksesta kuituulostulossa/julkisivulaatikossa',
        splicingFOS: 'Kuva liittämisestä FOS:ssa',
        sealingDuctFOS: 'Kuva tiivistyskanavasta FOS:ssa',
        hasOdfPortImage: 'Kuva ODF-portista',
        hasSwitchPortImage: 'Kuva Switchportista',
        hasNodeImage: 'Before and after image in node',
      },
    },
  },
  ...status,
  legend: {
    legendLabel: 'Selitys',
    filterLabel: 'Suodattaa',
    spanLayer: 'Linja',
    distpointLayer: 'Merkinnät',
    hc: 'HC – Talo Kytketty',
    hp: 'HP – Talo ohitettu',
    well: 'Kaivo',
    cabinet: 'Jakokaappi',
    site: 'Aktiivilaitepaikan',
    hub: 'Hub',
    jointpoint: 'Yhdyspiste',
    info: 'Lisätietopiste',
    trv: 'TRV - Pressing Point',
    sdp: 'Kanavan pääty',
    kp: 'KP - Duct Point',
    loa: 'Land owner areas',
    loaDone: 'Land agreement done',
    loaRequired: 'Land agreement missing',
    permitArea: 'Permit area',
    multiHp: 'Multi HP',
    multiHc: 'Multi HC',
    multiHousehold: 'Multi HP/HC',
    multiWell: 'Multi Kaivo',
    spanV2: {
      SELECTED: 'Valittu & linjat samassa raportissa',
      PLANNED: 'Suunniteltu',
      IN_PROGRESS: 'Käynnissä',
      DONE: 'Tehty',
      RESTORED: 'Palautettu',
      DEVIATED: 'Palautettu + Poikkeama',
      EXISTING: 'Olemassa oleva',
    },
    selectAll: 'Valitse kaikki',
  },
  definition: {
    unknown: 'Unknown',
    noTranslation: 'Translation unavailable',
  },
  projectOverview: {
    header: 'Projektin Yleiskatsaus',
    compileButton: 'Koota',
    from: 'Alkaen',
    to: 'To',
    compiledData: 'Kootut tiedot',
    reportCount: 'Raporttien määrä',
    totalPlannedDeviation: 'Ero suunniteltuun pituuteen',
    totalPerformed: 'Valmis pituus',
    tableHeaders: {
      method: 'Method',
      plannedLengthDeviation: 'Poikkeama suunnitellusta pituudesta (m)',
      performedLength: 'Valmiiksi (m)',
    },
  },
  duktsSidebar: {
    ductId: 'Mikrokanava id ',
    type: 'Tyyppi',
    color: 'Väri',
  },
  datepickerPlaceholder: 'YYYY-MM-DD',
  dateFormatError: 'Olet kirjoittanut väärän päivämäärän (VVVV-KK-PP).',
  tableConfiguration: {
    title: 'Säädä pöytä',
    cancel: 'Peruuttaa',
    apply: 'Käytä',
    showAllColumns: 'Näytä kaikki sarakkeet',
  },
  rolloutProgressLabel: 'Rollout Progress',
  ducts: 'Mikrokanavanippu',
  subDucts: 'Mikrokanava',
  searchDucts: 'Nimi, tunnus tai väri',
  clear: 'Poista',
  errorFetchingDucts: 'Kanavia ei voitu hakea',
  close: 'Sulje',
  searchDuct: 'Hae kanavaa',
  ordersOverview: {
    modalHeader: 'Tilauksen tiedot',
    formFilterHeader: 'Suodata',
    formFilterOrdersHeader: 'Suodata tilaukset',
    filterInputPlaceholder: 'Osoite, asiakkaan nimi, kaupunki..',
    mapMenuButton: 'Tilauksen tiedot',
    downloadExcel: 'Lataa Excel',
    downloadSuccess: 'CSExcelV-tiedosto ladattu',
    downloadError: 'Excel-tiedostoa ei voitu ladata.',
    downloadPdfStarted:
      'Luodaan PDF osoitteelle {address}. PDF:n luominen voi kestää hetki riippuen raportin koosta.',
    downloadPdfSuccess: 'PDF ladattu',
    downloadPdf429Title: 'Odota hetki',
    downloadPdfError429:
      'PDF:n luominen on varattu. Odota hetki ja yritä uudelleen.',
    downloadPdfErrorGeneric: 'PDF:n luominen epäonnistui. Yritä uudelleen.',
    downloadPdfCancelled: 'PDF-lataus peruutettiin, koska taulukko suljettiin.',
    downloadPdfCancelledPopup:
      'PDF-lataus peruutettiin, koska ponnahdusikkuna suljettiin.',
    filterOptions: {
      showAll: 'Näytä kaikki',
      incomplete: 'Näytä epätäydelliset',
      complete: 'Esitys valmis',
    },
    tableHeaders: {
      address: 'Katuosoite',
      completedDate: 'Valmistumispäivä',
      customerName: 'Asiakkaan nimi',
      latestStatus: 'Viimeisin tila',
      statusDate: 'Tilan päivämäärä',
      netAdminId: 'NetAdmin ID',
      customerInstallationDate: 'Asennuspäivämäärä',
      pdf: 'PDF',
      planedInstallationDate: 'Suunniteltu asennus',
      bookedCustomerInstallationDate: 'Varattu asennus',
      siteProjectPlanningExecutedDate: 'Suunniteltu Tonttisuunnittelu',
      siteShaftBooked: 'Suunniteltu Tonttikaivuu',
      siteShaftInstallationDate: 'Toteutettu Tonttikaivuu',
      fiberCableInstalledForCustomer: 'Kuitukaapeli asennettu',
      fiberReceiverInstallationDate: 'Kuitupäätelaitteen asennus',
      plotDesignDate: 'Tonttisuunnittelu',
      preinstallationDate: 'Esiasennus',
      plotExcavationDate: 'Tonttikaivuu',
      ductConnection: 'Kanavakytkennät',
      cableBlowingDate: 'Kuidun puhallus',
      splicingAndMeasuringDate: 'Hitsaus & Mittaus',
      splicingAndMeassuringDate: 'Hitsaus & Mittaus',
      splicingDate: 'Hitsaus',
      commissioningDate: 'Käyttöönotto',
      measuringDate: 'Mittaus',
      macAddress: 'MAC-osoite CPE',
    },
    true: 'Joo',
    false: 'Ei',
    error: 'Tilauksia ei voitu ladata, yritä myöhemmin uudelleen.',
    latestStatus: {
      ORDERED: 'Tilattu',
      ORDERED_FOR_BUILD: 'Tilattu rakentamiseen',
      CANCELLED: 'Peruutettu',
      REVOKED: 'Kumottu',
      WITHDRAWN: 'Veti pois',
      ESCALATED: 'Eskaloitunut',
      CONSTRUCTION_DEVIATION: 'Rakennuksen poikkeama',
      NOT_VALIDATED: 'Ei validoitu',
      WARNING: 'Varoitus',
      INSTALLED: 'Asennettu',
      UNKNOWN: 'Tuntematon',
    },
    status: 'Tila',
  },
  selfReportingPoints: {
    modalHeader: 'Kenttäraportti',
    cancelButton: 'Peruuta',
    proceedButton: 'Tallenna & sulje',
    unsavedChanges: 'Tallentamattomat muutokset. Säästä ennen sulkemista!',
    name: 'Nimi',
    object: 'Esine',
    uploadingFiles: 'Tiedostoja ladataan...',
    status: {
      header: 'Tila',
      started: 'Aloitettu',
      done: 'Valmis',
      doneWithDeviation: 'Tehty poikkeaman kanssa',
      deviationHeader: 'Kuvaile poikkeamaa',
      deviationPlaceholder: 'Kommentit…',
    },
    selfInspection: {
      header: 'Oman työn tarkistus',
      switchHeader: 'Lisää kuvaus',
      description:
        'Käy läpi jokainen kohta ja varmista, että työ on tehty kuvatulla tavalla. Huomaa, että jotkut kohteet vaativat kuvan, kun taas toiset voivat vaatia vain hyväksynnän valitsemalla valintaruudun.',
    },
    selfInspectionHeaders: {
      CABINET_ESTABLISHMENT: 'Kaapin asennus',
      FIBER_OPTICS: 'Kuitutyöt',
      LABELING: 'Merkinnät',
      MANHOLE_ESTABLISHMENT: 'Kaivon asennus',
      JOINT_BOX: 'Jatkoskotelo',
      RESTORATION: 'Ennallistaminen',
    },
    showCompleted: 'Näkymä tarkistettu',
    couldNotBeCompleted: 'Ei voitu suorittaa loppuun',
    uploadFile: 'Liitetiedosto',
    markComplete: 'Merkitse valmiiksi',
    pdfLink: 'Avaa ohjekuva uuteen ikkunaan',
    addImage: 'Lisää kuva',
    undoSelfInspection: 'Kumoa itsetarkistus ',
    addedBy: 'Lisännyt',
    alertCouldNotBeCompleted:
      'Tiettyjä itsetarkastuksia ei voitu suorittaa. Kuvaile sivun yläreunassa!',
    toastSaveSuccess: 'Muutoksesi on tallennettu!',
    errorPreventionSaveModal: {
      title: 'Haluatko tallenna tekemäsi muutokset?',
      confirm: 'Joo',
      deny: 'Ei',
    },
    error: 'Jokin meni pieleen. Ole hyvä ja kokeile myöhemmin uudestaan',
  },

  imageThumbnail: {
    addedBy: 'Lisännyt: ',
  },
  hpReportModal: {
    modalHeader: 'Suunnitelmia edistymisestä - HP',
    proceedButtonText: {
      create: 'Luoda',
      update: 'Päivittää ',
    },
    error: {
      noProps: 'Markerilla ei ole tietoja!',
    },
    pill: {
      done: 'Tehty',
      doneWithoutImages: 'Tehty ilman kuvia',
      notDone: 'Ei valmis',
      status: 'Tila',
      address: 'Katuosoite',
    },
    checkBox: 'Merkitse tehdyksi',
    images: {
      uploadedFiles: 'Ladatut kuvat',
      noUploadedFiles: 'Ei ladattuja kuvia',
      removeFilesButton: 'Poista kaikki',
      addFilesButton: {
        choose: 'Valitse tiedostot',
        more: 'Lisää enemmän +',
      },
    },
    toolTip: {
      removeFile: 'Poista kuva raportista',
      keys: {
        fileName: 'Tiedoston nimi',
        size: 'Koko',
        uploaded: 'Ladattu',
        createdBy: 'Ladannut',
        latitude: 'Leveysaste',
        longitude: 'Pituusaste',
      },
    },
    toast: {
      create: 'Raportti luotu HP:lle',
      update: 'Raportti päivitetty HP:lle',
      duplicateFileName: 'Kopioitu tiedostonimi! Tiedostoa varten',
      delete: 'Raportti poistettu',
    },
  },
  placmentImageLink: {
    title: 'Avaa ohjekuva uudessa välilehdessä',
  },
  imagePreview: {
    header: 'Kuvan esikatselu',
    upload: 'Lataa',
    cancel: 'Peruuta',
    noImages: 'Napsauta liittääksesi tiedostoja',
    loadingImages: 'Ladata kuvia...',
  },
  imagePreviewV2: {
    preview: 'Esikatselu',
    addImages: 'Lisää kuvia',
    close: 'Sulkea',
    downloadAll: 'Lataa kaikki',
    editImages: 'Muokata kuvia',
    manageImages: 'Hallitse kuvia',
    done: 'Valmis',
    deleteImageQuestion: 'Poista kuva?',
    confirmDelete: 'Kyllä, poista',
    cancel: 'Peruuttaa',
    confirmDeleteText: 'Haluatko varmasti poistaa tämän kuvan?',
    pleaseWait: 'Odota...',
    download: 'Lataa',
    images: 'Kuvia',
    imageDeleted: 'Kuva on poistettu',
    saved: 'Tallennettu!',
    uploaded: 'Ladattu',
    noImagesAvailable: 'Ei kuvia saatavilla',
    addImagesBelow: 'Voit lisätä kuvia alle!',
  },
  macAddressInvalid: 'Virheellinen MAC-osoite',
  Huvudbyggnad: 'Päärakennus',
  Extraanslutning_seperat_byggnad: 'Lisäasennus eri rakennukseen',
  Extraanslutning_inom_huvudbyggnad: 'Lisäasennus päärakennuksessa',
  searchComponent: {
    placeholder: 'Etsi osoite tai kohteen nimi',
  },
  workSectionStatus: {
    EXECUTED: 'Valmiiksi',
    PLANNED: 'Suunniteltu',
    AWAITING_PLANNING: 'Odottaa suunnittelua',
    INCOMPLETE: 'Epätäydellinen',
  },
  workSectionStatusTooltip: {
    EXECUTED: 'Työ on valmis',
    PLANNED: 'Työ on suunniteltu, mutta ei vielä valmis',
    AWAITING_PLANNING: 'Työtä ei ole vielä suunniteltu',
    INCOMPLETE: 'Souritettu puutteellisilla itsetarkastuksilla',
  },
  ductConnectionStatus: {
    NOT_CONNECTED: 'Ei yhteyttä',
  },
  fileUpload: {
    error: 'Tiedostoja ei voitu ladata',
    loadingImages: 'Ladata kuvia...',
  },
  select: 'Valitse ',
  tableFilter: {
    orderFilterssSectionHeader: ' valitut suodattimet',
    addFilterButton: 'Lisää suodatin',
    applyFilterButton: 'Käytä suodatinta',
    clearAllFiltersButton: 'Tyhjennä kaikki suodattimet',
    noFilteredOrders: 'Tilauksia ei löytynyt.',
    accessId: {
      existing: 'NetAdmin ID - Nykyinen',
      notExisting: 'NetAdmin ID - Ei ole olemassa',
    },
    plotDesign: {
      planned: 'Tonttisuunnittelu - Suunniteltu',
      awaitingPlanning: 'Tonttisuunnittelu - Odottaa suunnittelua',
      executed: 'Tonttisuunnittelu - Suoritettu',
    },
    preinstallation: {
      planned: 'Esiasennus - Suunniteltu',
      awaitingPlanning: 'Esiasennus - Odottaa suunnittelua',
      executed: 'Esiasennus - Suoritettu',
    },
    plotExcavation: {
      planned: 'Tonttikaivuu - Suunniteltu',
      awaitingPlanning: 'Tonttikaivuu - Odottaa suunnittelua',
      executed: 'Tonttikaivuu - Suoritettu',
    },
    ductConnection: {
      connected: 'Kanavakytkennät - Yhteyttä',
      notConnected: 'Kanavakytkennät - Ei yhteyttä',
    },
    cableBlowing: {
      planned: 'Kuidun puhallus - Suunniteltu',
      awaitingPlanning: 'Kuidun puhallus - Odottaa suunnittelua',
      executed: 'Kuidun puhallus - Suoritettu',
    },
    measuring: {
      planned: 'Hitsaus & Mittaus - Suunniteltu',
      awaitingPlanning: 'Hitsaus & Mittaus - Odottaa suunnittelua',
      executed: 'Hitsaus & Mittaus - Suoritettu',
    },
    commission: {
      planned: 'Käyttöönotto - Suunniteltu',
      awaitingPlanning: 'Käyttöönotto - Odottaa suunnittelua',
      executed: 'Käyttöönotto - Suoritettu',
    },
    perPage: 'Näytä per sivu: ',
  },
  multiPointModal: {
    header: {
      hp: 'Multi Talo Ohitettu',
      hc: 'Multi Talo Kytketty',
      well: 'Multi Kaivo',
      household: 'Multi Talo Kytketty & Ohitettu',
    },
    tabs: {
      hp: 'Talo Ohitettu',
      hc: 'Talo Kytketty',
      well: 'Kaivo',
    },
    closeBtn: 'Sulje',
  },
  feedbackAlert: {
    upload: {
      fileSuccess: 'Ladattu',
      success: 'Ladattu',
      error: 'Epäonnistui. Yritä uudelleen',
      tooLarge: 'Tiedosto on liian suuri (15 MT)',
    },
    undoSelfInspection: {
      success: 'Kumottu',
      error: 'Epäonnistui. Yritä uudelleen',
    },
    markAsNA: {
      success: 'Merkitty N/A',
      error: 'Epäonnistui. Yritä uudelleen',
    },
    save: {
      success: 'Tallennettu',
      error: 'Epäonnistui. Yritä uudelleen',
      spanAlreadyPartOfReport: 'Linja on jo olemassa toisessa raportissa',
    },
    remove: {
      success: 'Poistettu',
      error: 'Epäonnistui. Yritä uudelleen',
    },
  },
  reportStatus: {
    DONE_WITH_DEVIATION: 'Tehty poikkeamalla',
    UNKNOWN: 'Tuntematon',
    DONE_WITHOUT_IMAGES: 'Tehty ilman kuvia',
    NOT_STARTED: 'Ei aloitettu',
    PERMIT_DONE: 'Lupa - Hyväksytty',
    PLACEMENT_OF_SITE_DONE: 'Aktiivilaitepaikan sijoittaminen - Suoritettu',
    SITE_INSPECTION_DONE: 'Aktiivilaitepaikan Tarkistus - Käyttöönotettuna',
    PLACEMENT_OF_HUB_DONE: 'HUBin sijoittaminen - Suoritettu',
    HUB_INSPECTION_DONE: 'HUBin tarkastus -  Käytössä',
    DONE: 'Tehty',
    PLANNED: 'Suunniteltu',
    IN_PROGRESS: 'Meneillään',
    RESTORED: 'Kunnostettu',
    SETTING_CABINET_DONE: 'Kaapin asennus - Valmis',
    FIBER_WORK_DONE: 'Kuitutyö - Valmis',
    MARKING_DONE: 'Merkinnät - Valmis',
    SETTING_WELL_DONE: 'Kaivon asennus - Valmis',
    JOINT_BOX_DONE: 'Jatkoskotelo - Valmis',
    WELL_RESTORATION_DONE: 'Ennallistaminen - Valmis',
  },
  reportInfo: {
    lastUpdatedBy: 'Viimeksi päivittänyt',
    address: 'Katuosoite',
    objectName: 'Objektin nimi',
    status: 'Status',
    deviation: 'Poikkeama',
    reportStatusIcon: 'Raportin tilakuvake',
    referenceLabel: {
      SITE: 'Objektin nimi',
      HUB: 'Objektin nimi',
      HP: 'Katuosoite',
      SPAN: 'Linjan tunnus',
      CABINET: 'Kohteen nimi',
      MANHOLE: 'Kohteen nimi',
    },
    method: 'Menetelmä',
    spanType: 'Tyyppi',
    length: 'Pituus',
    meters: 'metriä',
    comment: {
      label: 'Kommentit',
      placeholder: 'Kirjoita jotain...',
    },
  },
  reportInput: {
    save: 'Tallenna',
    cancel: 'Peruuta',
    done: 'Tehty: ',
    na: 'N/A: ',
    addMore: 'Lisää lisää',
    upload: {
      files: 'Lataa tiedostoja',
      images: 'Lataa kuvia',
    },
    viewImages: 'Katsella kuvia',
    remove: 'Poista',
    download: 'Lataa',
    markAsDone: 'Merkitse tehdyksi',
    description: 'Kuvaus',
    instructionImage: 'Avoin ohje',
    optionsButton: {
      markAsNA: 'Merkitse ei-soveltuvaksi',
      editDescription: 'Muokkaa kuvausta',
      uploadImages: 'Lataa kuvia',
      undo: 'Kumoa itsetarkistus',
    },
    errorPreventionModal: {
      undoSelfInspectionQuestion: 'Perutaanko itsetarkastus?',
      undoSelfInspection: 'Kumoa itsetarkistus',
      cancel: 'Peruuttaa',
      text: 'Kaikki tiedot ja kuvat poistetaan, jos peruutat itsetarkastuksen.',
    },
    noPointReport: 'Merkkiä ei ole valitussa IFS:ssä',
    noSpanReport: 'Linjan ei ole valitussa IFS:ssä',
    errorReport:
      'Raporttia ei voitu hakea. Päivitä tai yritä myöhemmin uudelleen.',
    text: {
      label: 'Kuvaile syytä',
      placeholder: 'Kirjoita syytä...',
    },
  },
  signingCard: {
    title: 'Tonttisuunnitelman allekirjoittaminen',
    information:
      'Suorita kaikki vaaditut itsearvioinnit ja syötä suoritettu päivämäärä allekirjoituksen mahdollistamiseksi.',
    startSigning: 'Aloita allekirjoittaminen',
    newSigning: 'Uusi allekirjoitus',
  },
  spanAccomodationMethod: {
    unknown: 'Tuntematon',
    direct: 'Suoraan sijoitettu',
    softDigging: 'Imukaivuu',
    hammarDrilling: 'Iskuporaus',
    groundRocket: 'Maapora/Myyrä',
    chainDigging: 'Sahakaivuu',
    microTrenching: 'Mikrosahaus',
    plowing: 'Auraus',
    slotting: 'Urajyrsintä',
    guidedDrilling: 'Suuntaporaus',
    pressing: 'Painaminen',
    moving: 'Kaivuu',
    manualMoving: 'Lapiokaivuu',
    clamping: 'Kiinnitys',
    clampingOnRock: 'Kinnitys kallioon',
    clampingOnLadder: 'Kiinnitys kaapelitikkaaseen',
    existing: 'Oleva',
  },
  spanAccomodationType: {
    unknown: 'Unknown',
    ground: 'Ground',
    asphalt: 'Asphalt',
    tunnel: 'Tunnel',
    bridge: 'Bridge',
    radioLink: 'Radio link',
    air: 'Air',
    lake: 'Lake',
    field: 'Field',
    gravel: 'Gravel',
  },
  selectSpanMode: {
    title: 'Valitse linjaa raporttiin',
    editTitle: 'Muokataan linjaa raportissa',
    subtitle: 'Klikkaa linjaa, jotka haluat sisällyttää raporttiin.',
    editSubtitle: 'Klikkaa linjaa lisätäksesi tai poistaaksesi ne raportista.',
    meters: 'm',
    selectedDistance: 'Valittu etäisyys',
    cancel: 'Peruuta',
    createReport: 'Luo raportti',
    updateReport: 'Tallenna muutokset',
    warningMaxSpanLength: 'Useille linjoille sallitaan enintään 200 m.',
    help: 'Apua',
    spanExistsInOtherReport: 'Linjoja kuuluu toiseen raporttiin',
    propertySpanCannotBeReported: 'Tonttiväliä ei voida raportoida.',
    existingSpanCannotBeReported: 'Väli valmistunut toisessa projektissa.',
    helpModal: {
      title: 'Valita linjojas',
      spanColorGuide: {
        title: 'Linjan väriohje',
        colorNames: {
          cyan: 'Syaani',
          black: 'Musta',
          purple: 'Purppura',
          green: 'Vihreä',
          darkGreen: 'Tummanvihreä',
          red: 'Punainen',
        },
        description: {
          SELECTED: 'Valittu & linjat samassa raportissa',
          PLANNED: 'Suunniteltu',
          IN_PROGRESS: 'Käynnissä',
          DONE: 'Valmis',
          RESTORED: 'Palautettu',
          DEVIATED: 'Palautettu poikkeamalla',
        },
      },
      addingSpans: {
        title: 'Lisätä linjoja',
        body: 'Klikkaa linjoja valitaksesi ne. Valitut ja sisällytetyt linjat korostetaan syaanilla ja tehdään paksummiksi.',
      },
      removingSpans: {
        title: 'Poistaa linjoja',
        body: 'Klikkaa valittua (syaani) linjaa poistaaksesi valinnan. Korostus katoaa ja linja suljetaan raportista.',
      },
      spansNotAllowedForSelection: {
        title: 'Linjoja, joita ei voi valita',
        body: 'Linjoja muissa raporteissa ei voi valita. Poista ne ensin niiden nykyisestä raportista. Ne voivat olla eri värisiä tai mustia, jos ne kuuluvat suunniteltuun raporttiin.',
      },
    },
  },
  copied: 'Kopioitu',
  portConnectionStatus: {
    portConnection: 'Portin liitäntä',
    noMac: 'Preasennuksessa ei ole kelvollista MAC-osoitetta tai sarjanumeroa.',
    toPreinstallation: 'Siirry esiasennukseen',
    checkStatus: 'Tarkista portin liitännän tila.',
    checkConnection: 'Tarkista yhteys',
    loadingState: 'Tarkistetaan tilaa. Odota…',
    linking: 'Yhdistetty',
    notLinking: 'Ei yhdistetty',
    installationDate: 'Asennuspäivämäärä: ',
    checkAgain: 'Tarkista uudelleen',
    debugMessage: 'Vianmääritystä ja yritä tarkistaa uudelleen.',
  },
  fetchErrors,
  ...weekdays,
  ...months,
};
